import { render, staticRenderFns } from "./DigitalBusinessCardMain.vue?vue&type=template&id=79bdc1ea"
import script from "./DigitalBusinessCardMain.vue?vue&type=script&lang=js"
export * from "./DigitalBusinessCardMain.vue?vue&type=script&lang=js"
import style0 from "./DigitalBusinessCardMain.vue?vue&type=style&index=0&id=79bdc1ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports